(function () {
    console.log("🎨 Booking form styles script loaded");

    const injectStyles = () => {
        console.log("🔍 Looking for shopify-forms-embed...");

        const formEmbed = document.querySelector("shopify-forms-embed");
        if (!formEmbed) {
            console.log("⏳ Form embed not found, retrying...");
            setTimeout(injectStyles, 100);
            return;
        }

        console.log("✅ Form embed found:", formEmbed);

        const shadowRoot = formEmbed.shadowRoot;
        if (!shadowRoot) {
            console.log("⏳ Shadow root not found, retrying...");
            setTimeout(injectStyles, 100);
            return;
        }

        console.log("✅ Shadow root found:", shadowRoot);

        // Check if styles already injected
        const existingStyle = shadowRoot.querySelector("#custom-booking-styles");
        if (existingStyle) {
            console.log("ℹ️ Styles already injected, skipping...");
            return;
        }

        // Create style element
        const styleElement = document.createElement("style");
        styleElement.id = "custom-booking-styles";
        styleElement.textContent = `
    ._textHeading_2aowh_35 {
        font-family: 'GrecCrisp' !important;
        letter-spacing: 2px !important;
        color: #484848 !important;
        font-size: 38px !important;
        text-transform: uppercase !important;
        position: absolute !important;
        top: 12px !important;
        left: 0 !important;
        width: 100% !important;
        text-align: center !important;
        margin-bottom: 20px !important;
    }
      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        max-width: unset !important;
        margin: 0 auto !important;
        padding: 0 16px !important;
        }

    ._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
        max-width: 1160px !important;
        margin: 0 auto !important;
        display: flex !important;
        flex-direction: row-reverse !important;
        gap: 24px !important;
        padding-top: 85px !important;
        position: relative !important;  
    }
      ._formFieldset_cit2d_82 {
        max-width: 570px !important;
        border: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        font-family: 'P22StickleyProText' !important;
      }

      ._formFieldContainer_1mxsl_5 {
        display: inline-block !important;
        vertical-align: top !important;
        position: relative !important;
        margin: 16px 0 0 !important;
        padding-bottom: 24px !important;
        line-height: 24px !important;
        width: 100% !important;
      }

      ._formInputField_nag3b_7,
      ._formPhoneInputField_piv1u_17 {
        display: block !important;
        width: 100% !important;
        position: relative !important;
        background-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #767676 !important;
        padding: 0 !important;
        line-height: 1.71 !important;
        min-width: 150px !important;
        color: #000 !important;
        caret-color: #00a4b7 !important;
        transition: border-color 0.2s ease-out !important;
        box-sizing: border-box !important;
        outline: none !important;
        box-shadow: none !important;
        border-radius: unset !important;
        font-family: var(--body-font-stack) !important;
        font-weight: var(--body-font-weight) !important;
        font-style: var(--body-font-style) !important;
        font-size: 18px !important;
      }

      ._formInputField_nag3b_7:focus,
      ._formPhoneInputField_piv1u_17:focus {
        border-bottom-color: #000 !important;
        outline: none !important;
      }

      ._textArea_17mgw_1 {
        display: block !important;
        width: 100% !important;
        position: relative !important;
        background-color: transparent !important;
        border: 1px solid #767676 !important;
        padding: 12px !important;
        font-size: 16px !important;
        line-height: 1.71 !important;
        min-width: 150px !important;
        min-height: 120px !important;
        color: #000 !important;
        caret-color: #00a4b7 !important;
        transition: border-color 0.2s ease-out !important;
        resize: vertical !important;
        font-family: "P22StickleyProText" !important;
        box-sizing: border-box !important;
        outline: none !important;
      }

      ._textArea_17mgw_1:focus {
        border-color: #767676 !important;
        outline: none !important;
        box-shadow: none !important;
      }

      ._formInputFieldLabel_1mxsl_38 {
        display: block !important;
        position: absolute !important;
        color: #767676 !important;
        cursor: text !important;
        top: 0 !important;
        left: 1px !important;
        backface-visibility: hidden !important;
        z-index: 0 !important;
        transition: all 0.2s ease-out !important;
        transform-origin: left !important;
        line-height: 1.71 !important;
        pointer-events: none !important;
        font-family: 'P22StickleyProText' !important;
        font-size: 18px !important;
      }

      ._formInputField_nag3b_7:focus + ._formInputFieldLabel_1mxsl_38,
      ._formInputField_nag3b_7:not(:placeholder-shown) + ._formInputFieldLabel_1mxsl_38,
      ._formPhoneInputField_piv1u_17:focus + ._formInputFieldLabel_1mxsl_38,
      ._formPhoneInputField_piv1u_17:not(:placeholder-shown) + ._formInputFieldLabel_1mxsl_38,
      ._textArea_17mgw_1:focus + ._formInputFieldLabel_1mxsl_38,
      ._inputFilled_1mxsl_74 {
        transform: translateY(-20px) scale(0.83) !important;
        font-size: 18px !important;
        top: 0 !important;
      }
        ._textArea_17mgw_1:not(:placeholder-shown) + ._formInputFieldLabel_1mxsl_38 {
            font-size: 16px !important;
        }

      ._formPhoneInputContainer_piv1u_6 {
        display: flex !important;
        gap: 12px !important;
        align-items: flex-end !important;
        margin: 16px 0 0 !important;
      }
        ._textBody_2aowh_10 {
        font-family: 'GrecCrisp' !important;
        line-height: 1.6 !important;
        font-size: 18px !important;
        text-align: left !important;
        }
    ._textBody_2aowh_10 p strong, ._formBannerHeading_z5ku3_9 {
        font-family: 'GrecCrisp' !important;
        letter-spacing: 2px !important;
        font-size: 30px !important;
        font-weight: normal !important;
        color: #646464 !important;
        margin-bottom: 50px !important;
    }
        [data-testid="banner-success"] ._textBody_2aowh_10 {
            text-align: center !important;
        }

      .phone-country-selector {
        flex-shrink: 0 !important;
        width: 80px !important;
      }

      ._selectContainer_12thd_6 {
        position: relative !important;
        width: 100% !important;
      }
        .phone-country-selector {
        width: 150px !important;
        }

      ._selectToggle_12thd_25 {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
        padding: 11px 15px !important;
        background: #f7f7f7 !important;
        border: 1px solid #f7f7f7 !important;
        border-bottom: 1px solid #767676 !important;
        cursor: pointer !important;
        font-family: "MrsEavesRoman", serif !important;
        width: 100% !important;
        height: auto !important;
        box-sizing: border-box !important;
        border-radius: 0 !important;
        outline: none !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiPjxzd2l0Y2g+PGc+PHBhdGggZD0iTTEyIDE4LjI4LjE0NiA2LjQyNy44NTQgNS43MiAxMiAxNi44NjYgMjMuMTUgNS43MiAyMy44NTQgNi40Mjd6Ii8+PC9nPjwvc3dpdGNoPjwvc3ZnPg==) !important;
        background-repeat: no-repeat !important;
        background-position: calc(100% - 8px) center !important;
        background-size: 12px 12px !important;
        padding-right: 25px !important;
      }
      ._selectToggle_12thd_25:hover {
        border-bottom-color: #000 !important;
      }

      ._selectToggleText_12thd_25 {
        display: flex !important;
        align-items: center !important;
      }

      ._flagIcon_py6yc_5 {
        width: 24px !important;
        height: auto !important;
        display: block !important;
      }

      ._arrowDownIcon_12thd_19 {
        display: flex !important;
        align-items: center !important;
        margin-left: 4px !important;
        position: absolute !important;
        right: 8px !important;
        display: none !important;
      }

      ._arrowDownIcon_12thd_19 svg {
        width: 10px !important;
        height: auto !important;
      }

      ._birthdayText_rzr7e_15 {
        font-size: 16px !important;
        color: #767676 !important;
        margin-bottom: 12px !important;
        font-family: "P22StickleyProText" !important;
        text-transform: none !important;
        letter-spacing: normal !important;
      }

      ._dateFieldContainer_rzr7e_5 {
        display: grid !important;
        grid-template-columns: 1fr 1fr 2fr !important;
        gap: 16px !important;
      }

      [data-testid="date-birthday"] {
        margin: 16px 0 0 !important;
        padding-bottom: 24px !important;
      }

      ._formSubmitButton_cit2d_96 {
        padding: 10px 32px !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.1em !important;
        color: #ffffff !important;
        background-color: #014f5b !important;
        border: none !important;
        border-radius: 0 !important;
        cursor: pointer !important;
        transition: all 0.3s ease !important;
        margin-top: 0 !important;
        line-height: 22px !important;
        max-height: 42px !important;
        align-items: center !important;
        font-family: 'GrecCrisp' !important;
        letter-spacing: 2px !important;
        width: auto !important;
        border-radius: 0.5rem !important;
      }

      ._formSubmitButton_cit2d_96:hover {
        background-color: rgba(1, 79, 91, 0.85) !important;
      }

      ._formSubmitButton_cit2d_96:disabled,
      ._formSubmitButton_cit2d_96[aria-disabled="true"] {
        opacity: 0.5 !important;
        cursor: not-allowed !important;
      }

      ._formInputField_nag3b_7[aria-invalid="true"],
      ._formPhoneInputField_piv1u_17[aria-invalid="true"],
      ._textArea_17mgw_1[aria-invalid="true"] {
        border-color: transparent !important;
        border-bottom-color: #e31f26 !important;
      }

      ._formInputField_nag3b_7[aria-invalid="true"]:focus,
      ._formPhoneInputField_piv1u_17[aria-invalid="true"]:focus,
      ._textArea_17mgw_1[aria-invalid="true"]:focus {
        border-bottom-color: #000 !important;
      }

      .error-text,
      .form-message {
        display: block !important;
        color: #e31f26 !important;
        font-size: 15px !important;
        line-height: 1.6 !important;
        margin-top: 5px !important;
        font-family: 'GrecCrisp', serif !important;
      }

      .form-message {
        color: #d0621a !important;
      }

      ._formInputField_nag3b_7:disabled,
      ._formPhoneInputField_piv1u_17:disabled,
      ._textArea_17mgw_1:disabled {
        border-bottom-color: #e4e4e4 !important;
        color: #e4e4e4 !important;
      }

      ._formInputField_nag3b_7:disabled + ._formInputFieldLabel_1mxsl_38,
      ._formPhoneInputField_piv1u_17:disabled + ._formInputFieldLabel_1mxsl_38,
      ._textArea_17mgw_1:disabled + ._formInputFieldLabel_1mxsl_38 {
        color: #e4e4e4 !important;
      }

      @media screen and (max-width: 768px) {
        ._dateFieldContainer_rzr7e_5 {
          grid-template-columns: 1fr 1fr 1fr !important;
        }

        ._formPhoneInputContainer_piv1u_6 {
          flex-direction: column !important;
          align-items: stretch !important;
        }

        .phone-country-selector {
          width: 100% !important;
        }
      }
    ._formPhoneInputContainer_piv1u_6:has(.phone-country-selector) ._formFieldContainer_1mxsl_5 {padding: 0 !important;}
    ._formFieldContainer_1mxsl_5 textarea {z-index: 1 !important;}
    textarea + label._formInputFieldLabel_1mxsl_38 {
        top: unset !important;
        position: unset !important;
        z-index: 2 !important;
        font-size: #000 !important;
        transform: unset !important;
    }
    ._textArea_17mgw_1:focus + ._formInputFieldLabel_1mxsl_38 {
         transform: unset !important;
    }

    ._formFieldContainer_1mxsl_5:has(textarea + label._formInputFieldLabel_1mxsl_38 ) {
        display: flex !important;
        flex-direction: column-reverse !important;
    }
    `;

        // Inject styles into shadow root
        shadowRoot.appendChild(styleElement);

        console.log("✅ Booking form styles injected successfully!");
        console.log("📋 Injected style element:", styleElement);
        console.log(
            "🎯 Shadow root now contains:",
            shadowRoot.innerHTML.substring(0, 200) + "..."
        );
    };

    // Start checking for form
    if (document.readyState === "loading") {
        console.log("📄 Document still loading, waiting for DOMContentLoaded...");
        document.addEventListener("DOMContentLoaded", injectStyles);
    } else {
        console.log("📄 Document already loaded, starting injection...");
        injectStyles();
    }

    // Also observe for dynamic form loading
    console.log("👀 Setting up MutationObserver for dynamic form loading...");
    const observer = new MutationObserver((mutations, obs) => {
        const formEmbed = document.querySelector("shopify-forms-embed");
        if (formEmbed && formEmbed.shadowRoot) {
            console.log("🔄 Form detected via MutationObserver");
            injectStyles();
            obs.disconnect();
            console.log("👋 MutationObserver disconnected");
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    console.log("🚀 Booking form styles initialization complete");
})();
